export default __webpack_public_path__ + "static/media/mute.19d8e08e.svg";